// Module
var code = `<h3 class="text-uppercase">The Following license agreement Must be accepted in order to use this software</h3>

<div class="panel padding padding-lg text-center">
    <pre data-bind="text: eula">
    </pre>
</div>

<div class="navigation margin-top flex-horizontal">
    <div class="text-warning text-uppercase">Use of this software is forbidden without accepting the license agreement</div>
    <div class="flex-separator"></div>
    <button class="btn btn-primary btn-lg" data-bind="enable: canAccept() && !spinners.accept(), click: accept, css: { 'btn-spinner' : spinners.accept } ">
        <i class="icon-check"></i>
        <span>Accept</span>
    </button>
</div>
`;
// Exports
export default code;